export const PRIMARY_COLOR = '#9D8336';
export const PRIMARY_LITE_COLOR = '#F5F2EA';
export const PAGE_BACKGROUND_COLOR = '#FBFBFE';
export const FONT_FAMILY = 'Urbanist sans-serif';
export const SUCCESS_COLOR = '#63C32D';
export const ERROR_COLOR = '#E93E3E';
export const INFO_COLOR = '#21B8E8';
export const WARNING_COLOR = '#FFB302';
